import { ApiClient } from '../api';
import { Injectable, Optional } from '../components/dependency-injection/decorators';
import { Events } from '../components/event-manager/event/events';
import { TelemetryEvent } from '../components/event-manager/event/telemetry.event';
import { Logger } from '../components/logger/logger';
import { EventSubscriberInterface } from '../interfaces/components/event-manager/subscriber/event-subscriber.interface';

@Injectable()
export class TelemetrySubscriber implements EventSubscriberInterface {
  public constructor (
    private readonly apiClient: ApiClient,
    @Optional() private readonly logger?: Logger,
  ) {
  }

  public getSubscribedEvents (): { [key in Events]?: string } {
    return {
      [ Events.TELEMETRY_EVENT ]: 'onTelemetryEvent',
    };
  }

  public async onTelemetryEvent (event: TelemetryEvent): Promise<void> {
    this.logger?.debug(`Registering event: ${event.getId()}`);
    // return this.apiClient.registerEvent(event.getAdSlotIdentifier(), {
    //   // eventType: event.getType(),
    //   // encryptedPayload: event.getPayload(),
    // });
  }
}
